import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api.js'; // .js 확장자 추가

// 1. Context 생성
const AuthContext = createContext();

// 2. AuthProvider 컴포넌트 (앱 전체를 감쌀 컴포넌트)
export const AuthProvider = ({ children }) => {
  // ⬇️ [수정] sessionStorage에서 'user'와 'token'을 읽어와 초기 상태로 설정
  const [user, setUser] = useState(() => {
    try {
      const storedUser = sessionStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (e) {
      return null;
    }
  });
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  
  // ⬇️ [수정] 앱이 처음 로드될 때 토큰 유효성 검사 (로직 단순화)
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    // (선택사항) 토큰 유효성을 검사하는 API(/api/users/profile 등)를
    // 여기에 추가하면 더 안전합니다.
    // 현재는 sessionStorage에 토큰이 있으면 로그인된 것으로 간주합니다.
    setLoading(false);
  }, []); // ⬅️ [수정] 앱 마운트 시 한 번만 실행

  // 로그인 함수 — 성공 시 { success: true }, 실패 시 { success: false, message }
  const login = async (userId, password) => {
    try {
      const res = await api.post('/auth/login', { userId, password });

      sessionStorage.setItem('token', res.data.token);
      sessionStorage.setItem('user', JSON.stringify(res.data.user));

      setToken(res.data.token);
      setUser(res.data.user);

      return { success: true };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        '아이디 또는 비밀번호가 올바르지 않습니다.';
      console.error('로그인 실패:', message);
      return { success: false, message };
    }
  };

  // 로그아웃 함수
  const logout = () => {
    // ⬇️ [수정] sessionStorage에서 토큰과 'user' 객체 삭제
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user'); // ⬅️ [추가] user 삭제
    setToken(null);
    setUser(null);
  };

  if (loading) {
    return <div>로딩 중...</div>;
  }

  // 3. Context Provider로 하위 컴포넌트에 값 전달
  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

// 4. useAuth 훅 (다른 컴포넌트에서 쉽게 사용하기 위함)
export const useAuth = () => {
  return useContext(AuthContext);
};
